import request from '@/plugin/axios/request';
import constKey from '@/const/constKey'

export function downLoadFile(filedata) {
  console.log('filedata',filedata)
  return request({
    url: '/v1/downLoadFile',
    method: 'get',
    responseType: 'blob',
    params: {
      sID: 'xagl.Service',
      tID: filedata.fileId
    }
  });
}

export function upLoadFile(fid,filedata) {
  return request({
    url: '/v1/upLoadFile',
    method: 'post',
    contentType:  "multipart/form-data",
    params: {
      sID: 'xagl.Service',
      tID: fid
    },
    processData: false,  
    cache: false,  
    data: filedata
  });
}

export function doUserRegAdd(data) {
  return request({
    url: '/v1/userRegAdd',
    method: 'post',
    params: {
      sID: 'xagl.Service',
      tID: 'doUserRegAdd'
    },
    data: {
      [constKey.KEY_DATA.reqDATA]: data
    }
  });
}

export function doUserRegQuery(queryid) {
  return request({
    url: '/v1/userRegQuery',
    method: 'post',
    params: {
      sID: 'xagl.Service',
      tID: 'doUserRegQuery'
    },
    data: {
      'qTy': '0',
      'qNo': queryid,
    }
  });
}

export function doUserPaireQuery(queryid) {
  return request({
    url: '/v1/userPaireQuery',
    method: 'post',
    params: {
      sID: 'xagl.Service',
      tID: 'doUserPaireQuery'
    },
    data: {
      'qTy': '1',
      'qNo': queryid,
    }
  });
}

export function doUserChangeQuery(queryid) {
  return request({
    url: '/v1/userChangeQuery',
    method: 'post',
    params: {
      sID: 'xagl.Service',
      tID: 'userChangeQuery'
    },
    data: {
      'qTy': '2',
      'qNo': queryid,
    }
  });
}


export function doUserInvoice(data) {
  return request({
    url: '/v1/userInvoice',
    method: 'post',
    params: {
      sID: 'xagl.Service',
      tID: 'doUserInvoice'
    },
    data: {
      [constKey.KEY_DATA.reqDATA]: data
    }
  });
}

export function doUserScore(data) {
  return request({
    url: '/v1/userScore',
    method: 'post',
    params: {
      sID: 'xagl.Service',
      tID: 'doUserScore'
    },
    data: {
      [constKey.KEY_DATA.reqDATA]: data
    }
  });
}



export function queryUserInvoice(queryid) {
  return request({
    url: '/v1/userInvoiceQuery',
    method: 'post',
    params: {
      sID: 'xagl.Service',
      tID: 'userInvoiceQuery'
    },
    data: {
      'qNo': queryid,
    }
  });
}
